import { render, staticRenderFns } from "./ConcentratorManagement.vue?vue&type=template&id=065f3501&scoped=true"
import script from "./ConcentratorManagement.vue?vue&type=script&lang=js"
export * from "./ConcentratorManagement.vue?vue&type=script&lang=js"
import style0 from "./ConcentratorManagement.vue?vue&type=style&index=0&id=065f3501&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065f3501",
  null
  
)

export default component.exports